import PermissionSettingManager from './manager'
import PermissionSettingAdd from './detail'

export {
  PermissionSettingManager,
  PermissionSettingAdd
}
